import { Text } from './uixy';

import { Calendar } from './components/Calendar';

export const App = () => {
    return (
        <div>
            <Text kind="title" style={{ marginBottom: '20px' }}>
                Push Ups
            </Text>

            <Calendar />
        </div>
    );
};
